import { Button, CircularProgress } from "@mui/material";
import React from "react";

type ButtonProps = {
  titulo: string;
  isSubmitting: boolean;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  icon?: any;
  onSave?: () => void;
};

export function SaveButton(props: ButtonProps) {
  return (
    <Button
      type="submit"
      startIcon={props.icon}
      size={props.size}
      variant="contained"
      disabled={props.isSubmitting || props.disabled}
      color={props.isSubmitting ? "inherit" : "primary"}
      onClick={() => {
        props.onSave ? props.onSave() : console.log("Save!");
      }}
      sx={{
        background: props.isSubmitting ? "#EEE" : "#2813AD",
        color: "#FFF",
        border: 0,

        "&:hover": {
          border: 0,
          background: props.isSubmitting ? "#EEE" : "#2813AD",
        },
      }}
    >
      {props.isSubmitting ? (
        <CircularProgress size={24} sx={{ color: "#FFF" }} />
      ) : (
        <>{props.titulo}</>
      )}
    </Button>
  );
}
